import React from 'react';
import {
	Button,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Text,
} from '@tempo/core';
import {useTranslation} from 'next-i18next';

type DeleteAccountModalProps = {
	isOpen: boolean;
	isCurrentUser: boolean;
	onClose: () => void;
	onDelete: () => void;
};

const DeleteAccountModal = ({
	isOpen,
	isCurrentUser,
	onClose,
	onDelete,
}: DeleteAccountModalProps) => {
	const {t} = useTranslation('d4c');
	return (
		<Modal isOpen={isOpen} onClose={onClose}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>
					{isCurrentUser
						? t('profilesettings_action_deletemyaccount_d4c-web')
						: t('generic_action_deleteaccount_d4c-web')}
				</ModalHeader>
				<ModalCloseButton border="none" boxSizing="border-box" />
				<ModalBody>
					<Text
						color="text.neutral.secondary.default"
						variant="body.default.regular"
					>
						{isCurrentUser
							? t('toastmessage_text_deleteaccountnotreversible_d4c-web')
							: t('toastmessage_text_suretodeletethisuser_d4c-web')}
					</Text>
				</ModalBody>

				<ModalFooter>
					<Button
						data-testid={
							isCurrentUser
								? 'my-profile-delete-modal-cancel-button'
								: 'user-manager-delete-modal-cancel-button'
						}
						onClick={onClose}
						variant="ghost"
					>
						{t('generic_action_cancel_d4c-web')}
					</Button>
					<Button
						data-testid={
							isCurrentUser
								? 'my-profile-delete-modal-confirm-button'
								: 'user-manager-delete-modal-confirm-button'
						}
						sx={{
							bg: 'background.feedback.error.default',
							_hover: 'background.feedback.error.default',
						}}
						onClick={onDelete}
					>
						{t('generic_action_delete_d4c-web')}
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default DeleteAccountModal;
